import { RefNo } from '../../model/ngrx/reference-number.model';
import * as RefNoActions from './../actions/reference-number.actions';

export type Actions = RefNoActions.Actions;

export function refReducer(state: RefNo[] = [], action: RefNoActions.Actions) {
    switch (action.type) {
        case RefNoActions.ADD_REFNO:
            return [...state, action.payload];

        // Add this case:
        case RefNoActions.REMOVE_REFNO:
            state = [];
            return state;
        // Add this case:
        case RefNoActions.EDIT_REFNO:
            if (state.length > 0) {
                let localState = state[0];
                localState = {...localState, quoteNumberFlag: action.payload};
                state = [...state.slice(1), localState];
            }
            return state;
        default:
            return state;
    }
}
